import { __ } from '@wordpress/i18n';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { getSetting } from '@woocommerce/settings';
import { useEffect } from '@wordpress/element'
import {
    get_paysafe_label,
    main_paysafe_checkout_success_handler,
    resolve_paysafe_payment_description,
    set_log_nonce
} from "./paysafe-common";
import { paysafe_sha512 } from './paysafe-encrypt';


const paymentMethodId = "paysafecash";
const settings = getSetting( paymentMethodId + '_data', {} );
set_log_nonce(settings.nonce);

let currentCartData = {};

const Content = ( props ) => {
    const { eventRegistration, emitResponse } = props;
    const { onCheckoutSuccess } = eventRegistration;

    useEffect(() => {
        const unsubscribe = onCheckoutSuccess( (response) => {

            let consumer_id = settings.consumer_id_encrypted;
            if (!consumer_id) {
                consumer_id = paysafe_sha512(currentCartData.billingAddress.email);
            }

            return main_paysafe_checkout_success_handler(
                response,
                currentCartData,
                    settings, {
                    displayPaymentMethods: [
                        'paysafecash'
                    ],
                    paymentMethodDetails: {
                        paysafecash: {
                            accountId: settings.account_id,
                            consumerId: consumer_id,
                        }
                    }
                }, false, emitResponse);
        });

        return () => {
            unsubscribe();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        '',
        [],
        onCheckoutSuccess,
    ]);

    return resolve_paysafe_payment_description(settings);
};

const PaysafePaysafeCardPayments = {
    name: paymentMethodId,
    paymentMethodId: paymentMethodId,
    label: get_paysafe_label(settings.title, settings.icon),
    content: <Content/>,
    edit: <Content/>,
    canMakePayment: (cartData => {
        currentCartData = cartData;

        return true;
    }),
    ariaLabel: __('Paysafe Checkout', 'paysafe-checkout' ),
    supports: {
        features: settings.supports,
    },
};

registerPaymentMethod(PaysafePaysafeCardPayments);
